import React, { useState } from "react";
import { postApi } from "../../services/api/postApi";
import { FaBookmark, FaTimes } from "react-icons/fa";
import "./SavePostModal.css";

const SavePostModal = ({ isOpen, onClose, postId, onSuccess }) => {
  const [collection, setCollection] = useState("");
  const [tags, setTags] = useState("");
  const [notes, setNotes] = useState("");
  const [priority, setPriority] = useState("medium");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const saveData = {};

      // Add optional fields only if they have values
      if (collection.trim()) {
        saveData.collection = collection.trim();
      }

      if (tags.trim()) {
        saveData.tags = tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean);
      }

      if (notes.trim()) {
        saveData.notes = notes.trim();
      }

      if (priority) {
        saveData.priority = priority;
      }

      const response = await postApi.savePost(postId, saveData);

      if (response.data.success) {
        alert("Post saved successfully!");
        if (onSuccess) {
          onSuccess(response.data.savedPost);
        }
        onClose();
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Failed to save post. Please try again.";
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="spm-overlay" onClick={onClose}>
      <div className="spm-content" onClick={(e) => e.stopPropagation()}>
        <div className="spm-header">
          <h3 className="spm-title">
            <FaBookmark className="spm-header-icon" /> Save Post
          </h3>
          <button
            className="spm-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="spm-form">
          {/* Collection Name */}
          <div className="spm-form-group">
            <label htmlFor="collection">Collection (optional)</label>
            <input
              type="text"
              id="collection"
              value={collection}
              onChange={(e) => setCollection(e.target.value)}
              placeholder="e.g., Research Questions, Important Papers"
              maxLength={100}
            />
            <small className="spm-hint">
              Organize your saved posts into collections
            </small>
          </div>

          {/* Tags */}
          <div className="spm-form-group">
            <label htmlFor="tags">Tags (optional)</label>
            <input
              type="text"
              id="tags"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="important, review-later, machine-learning"
              maxLength={200}
            />
            <small className="spm-hint">
              Add tags separated by commas for easy filtering
            </small>
          </div>

          {/* Notes */}
          <div className="spm-form-group">
            <label htmlFor="notes">Notes (optional)</label>
            <textarea
              id="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Why are you saving this? Add your thoughts..."
              rows={4}
              maxLength={500}
            />
            <small className="spm-char-count">{notes.length}/500</small>
          </div>

          {/* Priority */}
          <div className="spm-form-group">
            <label htmlFor="priority">Priority (optional)</label>
            <select
              id="priority"
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
            <small className="spm-hint">
              Set priority to organize your reading list
            </small>
          </div>

          <div className="spm-actions">
            <button
              type="button"
              onClick={onClose}
              className="spm-cancel-btn"
              disabled={loading}
            >
              Cancel
            </button>
            <button type="submit" className="spm-submit-btn" disabled={loading}>
              {loading ? "Saving..." : "Save Post"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SavePostModal;
